<template>
    <div>
        Mit Aktivierung dieser Option legen Sie fest, dass
        <strong>alle zurückliegenden Termine</strong> automatisch nach X Tagen/Monaten <strong>anonymisiert</strong> werden.
        <br>
        Dabei werden alle persönlichen Daten <strong>unwiderruflich</strong> gelöscht.
        <br/>
        <br/>
        Die automatische Anonymisierung der Termine wird vom System ab dem nächsten Tag 1x täglich um ca. 6 Uhr vorgenommen.
        <br>
    </div>
</template>

<script lang="ts">
    import {Component,Vue} from 'vue-facing-decorator';
    import {popupDefaultCancelButton} from '../../../../library/popup';

    @Component({
        name: 'AnonymizeEntries',
        components: {},
        emits: ['confirmed'],
    })
    export default class AnonymizeEntries extends Vue
    {
        created()
        {
            this.emitter.emit('setButtons', [
                popupDefaultCancelButton,
                {
                    title: 'Verstanden',
                    type: 'primary',
                    icon: 'check_circle',
                    cmd: () =>
                    {
                        this.emitter.emit('confirmed');
                        this.emitter.emit('close');
                    },
                },
            ]);
        }
    }
</script>